<template>
	<div class="huifei" v-if="showHuifei">
		<div class="con">
			<div class="shade" v-show="ma" @click="shade_closed">
				<div>
					<p style="color: red;text-align: center;">注：转账请备注个人会员姓名</p>
					<img src="../../static/img/ma.png" />
				</div>	
			</div>
			<p class="con_tit"><i></i><strong>缴纳会费</strong> <span v-show="person" style="font-size: 14px;color: red;">(个人会员如需要开具发票，请致电联系会员服务部工作人员)</span></p>
			<div class="con_con">
				<div class="con_con_top">
					<a v-show="shenqing" style="cursor: pointer;" @click="childMethod">申请会费票据</a>
					<p class="con_con_top_tit">缴费转账信息</p>
					<p class="con_con_top_msg">
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>收款方户名：中国质量协会</span><i v-if="person">请注明项目：会费 <b style="font-weight: bold;">及个人会员姓名</b></i><i v-else="">请注明项目：会费</i><br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;收款方账号：0200002809014498969
						<br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;收款方银行：工商银行
						<br> &nbsp;&nbsp;收款方开户分行：工商银行北京西四支行
					</p>
				</div>

				<div class="con_con_center">
					<img class="icon" src="../../static/img/copy5.png" />
					<p>会员有效期：<span :class="sign==1?'red':''">{{time}}</span>会员类型：{{zhiwei}}</p>
					<p><span>{{year}}</span> <strong>续费费用：{{money}}</strong></p>
					<div v-if="person">
						<div class="codeMsg">
							<input v-model="code" :class="type== 1? 'b1':'b2'" @input="changeType" placeholder="请填写本次缴费的转账卡号或支付宝账号，以便工作人员确认转账信息" />
							<span @click="submitCode">提交</span>
						</div>	
						<p style="text-align: left;font-size: 14px;margin-bottom: 10px;color: #404040;font-weight: bold;">个人会员请选择支付宝付款</p>
						<div style="width: 100%;height: 50px;margin-bottom: 20px;">
							<div class="pay_box">
								<input type="radio"  style="vertical-align: middle;" checked/>
								<img style="display: inline-block;width: 28px;height: 29px;vertical-align: middle;" src="../../static/img/pay.png" />
								<span>支付宝付款</span>
								<span style="float:right;height: 100%;line-height: 50px;color: #FF3838;margin-right: 20px;" >¥480/年</span>
							</div>
							<button  class="pay_btn" @click="pay">立即支付</button>
						</div>	
						<!--<p style="text-indent: 85px;color: #CFD4D6" v-show="person">{{filename}}</p>-->
						<div class="payment">
							<!--<span class="jfpz">缴费凭证</span>
							<div class="add">
								<label for="file" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 10; "></label>
								<input type="file" id="file" class="file" @change="uploadFile($event)" multiple="multiple" accept='image/jpeg,image/png'>
							</div>
							<span class="upload" @click="upload">提交</span>-->
							<span style="font-size: 16px;font-weight: bold;color: #404040;">缴费状态：</span>
							<span  :class="status=='需缴费'?'red':'type'">{{status}}</span>
						</div>
						<!--<p class="note" v-show="person">支持扩展名： .png .jpg</p>-->
					</div>
					<div class="up_box" v-else>
						<span class="jfpz">查询缴费进度：</span>
						<button class="up" @click="query">申请查看缴费状态</button>
						<span style="font-size: 16px;font-weight: bold;color: #404040;">缴费状态：</span>
						<span  :class="status=='需缴费'?'red':'type'">{{status}}</span>
						<p style="color: #ff4e4e;font-size: 12px;text-indent: 120px;line-height: 25px;">（请确认缴费后点击此按钮）</p>
					</div>					
				</div>

				<div class="con_con_bot">
					<p style="line-height: 45px;font-size: 16px;font-weight: bold;" class="con_con_bot_tit">缴费记录</p>
					<ul class="ul1">
						<li class="w1">事项</li>
						<li class="w2">金额</li>
						<li class="w2">缴费时间</li>
						<li class="w3">操作</li>
					</ul>
					<div class="page_con">
						<ul v-for='(item,index) in tableData' class="ul2" :data="allTableData.slice((paginations.page_index-1)*paginations.page_size,paginations.page_index*paginations.page_size)">
							<li class="w1">{{item.year}}</li>
							<li class="w2">{{item.money}}</li>
							<li class="w2">{{item.gained_date}}</li>
							<li class="w3">{{item.invoice_status}}</li>
						</ul>
					</div>

					<el-pagination style="width: 45%;height: 35px;border:none;padding: 0;margin: 0 auto;text-align: center;" @size-change="handleSizeChange" @current-change='current' :page-size="paginations.page_size" :current-page="paginations.page_index" :layout="paginations.layout" :total="paginations.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	import { MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				type:1,
				code:'',
				ma:false,
				file: '',
				filename: '',
				person:false,
				shenqing: true,
				status: '',
				time: '',
				zhiwei: '',
				year: '',
				money: '',
				sign:'',
				tableData: [], //数据
				paginations: {
					page_index: 1, //当前页
					total: 0, //总数
					page_size: 5, //一页显示多少
					layout: 'prev, pager, next'
				},
				allTableData: [], //    每页的数据	
			};
		},
		props: {
			showHuifei: {
				type: Boolean
			}
		},
		created() {
			this.getInfoList();
		},
		mounted() {

			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			if(sessionStorage.getItem('type') == 3) {
				this.shenqing = false;
				this.person = true;
			};
			var data1 = {
				'access-token': token
			};
			this.$axios({
				method: 'post',
				url: 'payment/paymentpage',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state == 3) {
					this.time = response.data.result.endTime;
					this.zhiwei = response.data.result.role;
					this.year = response.data.result.paymentTimes;
					this.money = response.data.result.fees;
					this.status = response.data.result.paymentStatus;
					this.sign = response.data.result.sign;
				}
			});

		},
		methods: {
			changeType(){
	    		if(this.code){
	    			this.type =2;
	    		}else{
	    			this.type =1;
	    		}	    		
	    	},
	    	submitCode(){
	    		if(!this.code){
	    			this.$message('请填写本次缴费的转账卡号或支付宝账号!');
	    			return false;
	    		}
	    		if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
	    		var data1={
	    			'access-token':token,
					account:this.code
				};
	    		this.$axios({
						method: 'post',
						url: 'personal/updateaccount',
						data: Qs.stringify(data1)
					}).then(response => {
						this.$message(response.data.msg);				
					});	 
	    	},
	    	pay(){
				var time = new Date();
				var month = time.getMonth() + 1;
				var date = time.getDate();
				if(month==11 && date>=30){
					this.$alert('尊敬的个人会员，自11月30日起至12月31日，中国质量会财务结算期间，支付宝渠道暂时关闭，请通过协会银行账户汇款缴纳会费，感谢您的理解与配合！', '温馨提示：', {
			          confirmButtonText: '确定',
			       });
					return false;
				}else if(month==12 && date<=31){
					this.$alert('尊敬的个人会员，自11月30日起至12月31日，中国质量会财务结算期间，支付宝渠道暂时关闭，请通过协会银行账户汇款缴纳会费，感谢您的理解与配合！', '温馨提示：', {
			          confirmButtonText: '确定',
			       	});
					return false;
				};
				this.ma=true;
			},
			shade_closed(){
				this.ma=false;
			},
			uploadFile(event) {
				const isLt2M = event.target.files[0].size / 1024 / 1024 < 10 // 上传头像图片大小不能超过 2MB
				if(!isLt2M) {
					this.$toast('图片选择失败，每张图片大小不能超过 10MB,请重新选择!');
				} else {
					this.file = event.target.files[0]; //获取input的图片file值
					this.filename = event.target.files[0].name;
					this.$toast('文件选择成功!');
					
				}
			},
			upload() {
				if(this.filename == "") {
					this.$toast('请选择要上传的文件！')
					return false
				};
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
				let fileFormData = new FormData();
				fileFormData.append('file', this.file, this.filename); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
				fileFormData.append('access-token',token);
				
				let requestConfig = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				};
				this.$axios.post('payment/checkpaymentprogress', fileFormData, requestConfig).then(response => {
					this.$toast(response.data.msg);
				});
			},
			
			childMethod() {
				this.$parent.tabNav(2);
			},
			query() {
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1 = {
					'access-token': token
				};
				this.$confirm('请您和公司财务确认，已经按提示完成了转账缴费事宜。', '注意', {
			        distinguishCancelAndClose: true,
			        confirmButtonText: '确认已缴费',
			        cancelButtonText: '还未交费'
			    })
			    .then(() => {
			       	this.$axios({
						method: 'post',
						url: 'payment/checkpaymentprogress',
						data: Qs.stringify(data1)
					}).then(response => {
						this.$toast(response.data.msg)				
					});	  
			    })
			    .catch(action => {
			    });
//				this.$axios({
//					method: 'post',
//					url: 'payment/checkpaymentprogress',
//					data: Qs.stringify(data1)
//				}).then(response => {
//					this.$toast(response.data.msg)
//				});
			},
			//缴费记录 分页
			getInfoList() {
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1 = {
					'access-token': token
				};
				this.$axios({
					method: 'post',
					url: 'payment/paymentprogress',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state == 2) {
						if(response.data.List.data.length != 0) {
							this.allTableData = response.data.List.data;
							this.setPaginations();
						}
					}

				})
			},
			setPaginations() {
				this.paginations.total = this.allTableData.length; //数据的数量
				this.paginations.page_index = 1; //默认显示第一页
				this.paginations.page_size = 3; //每页显示多少数据
				//显示数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < this.paginations.page_size;
				})
			},
			handleSizeChange(page_size) {
				this.paginations.page_index = 1; //第一页
				this.paginations.page_size = page_size; //每页先显示多少数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < page_size
				})
			},
			current(page) {
				// 跳转页数
				//获取当前页
				let index = this.paginations.page_size * (page - 1);
				//获取总数
				let allData = this.paginations.page_size * page;

				let tablist = [];
				for(let i = index; i < allData; i++) {
					if(this.allTableData[i]) {
						tablist.push(this.allTableData[i])
					}
					this.tableData = tablist
				}
			},
		}
	}
</script>
<style scoped>
	.red{
		color: red;
	}
	.type{
		color: rgb(90, 187, 170);
	}
	.huifei {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 100%;
		/*height: 935px;*/
		height: auto;
	}
	
	.con_tit {
		padding-left: 18px;
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		box-sizing: border-box;
	}
	.con_tit i{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	
	
	.con_con {
		padding: 49px 41px 0 148px;
		box-sizing: border-box;
	}
	
	.con_con_top {
		position: relative;
		width: 100%;
		height: 181px;
		border-bottom: 1px solid rgba(207, 212, 214, 1);
	}
	
	.con_con_top_tit {
		font-size: 16px;
		font-weight: bold;
		width: 96px;
		height: 20px;
		line-height: 20px;
		margin-bottom: 10px;
		padding-left: 28px;
		background: url(../../static/img/card.png) no-repeat top 2px left 0;
		background-size: 21px 16px;
	}
	
	.con_con_top_msg {
		line-height: 35px;
		color: rgba(64, 64, 64, 1);
	}
	
	.con_con_top_msg span {
		display: inline-block;
		margin-right: 73px;
	}
	
	.con_con_top a {
		position: absolute;
		right: 0;
		bottom: 69px;
		width: 124px;
		height: 40px;
		background: rgba(255, 150, 0, 1);
		border-radius: 3px;
		color: #fff;
		line-height: 40px;
		text-align: center;
	}
	
	.con_con_center {
		padding: 43px 0;
		position: relative;
		height: auto;
		width: 100%;
		border-bottom: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		color: rgba(64, 64, 64, 1);
	}
	
	.con_con_center .icon {
		width: 60px;
		height: 60px;
		position: absolute;
		left: -100px;
		top: 42px;
	}
	
	.con_con_center p:nth-of-type(1) {
		margin-bottom: 11px;
	}
	
	.con_con_center p:nth-of-type(1) span {
		display: inline-block;
		width: 130px;
		margin-right: 40px;
	}
	
	.con_con_center p:nth-of-type(2) {
		margin-bottom: 25px;
		position: relative;
	}
	
	.con_con_center p:nth-of-type(2) span {
		margin-left: 85px;
		color: #FF9600;
	}
	
	.con_con_center p:nth-of-type(2) strong {
		position: absolute;
		top: 0;
		left: 254px;
	}
	.codeMsg{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 34px;
	}
	.codeMsg input{
		height: 40px;
		width: 485px;
		margin-right: 15px;
		box-sizing: border-box;
		text-indent: 10px;
		border-radius: 3px;
	}
	.codeMsg span{
		cursor: pointer;
		width: 80px;
		height: 40px;
		background: rgba(24, 144, 255, 1);
		color: #fff;
		border-radius:3px ;
		text-align: center;
		line-height: 38px;
	}
	.b1{
		border: 2px solid red;
	}
	.b2{
		border: 2px solid #66b92e;
	}
	.codeMsg span:hover{
		background: blue;
	}
	.shade{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.7);
		z-index: 99;
	}
	.shade div{
		width: 300px;
		height:300px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
	.shade img{
		width: 300px;
		height:300px;
	}
	.shade p{
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		font-size: 16px;
	}
	
	.pay_box{
		width:438px;
		height:50px;
		border-radius:3px;
		border:1px solid rgba(211,211,211,1);
		box-sizing: border-box;
		float: left;
		margin-right: 15px;
		line-height: 50px;
	}
	.pay_btn{
		float:left;
		width:125px;
		height:48px;
		background: rgba(24, 144, 255, 1);
		border-radius:3px;
		border: none;
		color: #fff;
	}
	.pay_btn:hover{
		background: blue;		
	}
	
	.payment{
		width: 583px;
		height: auto;
		line-height: 32px;
	}
	
	.add {
		vertical-align: middle;
		display: inline-block;
		position: relative;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 32px;
		width: 106px;
		height: 32px;
		background: rgba(255, 255, 255, 1) url(../../static/img/input.png) no-repeat;
		background-size: 100%;
		margin: 0 37px 0 15px;
	}
	.add:active{
		background: rgba(24, 144, 255, 1);
		color: #fff;
		border:none;
	}
	.file {
		position: absolute;
		left: -9999px;
	}
	
	.upload {
		margin-right: 35px;
		cursor: pointer;
		text-align: center;
		display: inline-block;
		width: 53px;
		height: 31px;
		background: rgba(0, 118, 255, 1);
		border-radius: 3px;
		color: #fff;
	}
	
	.note {
		line-height: 30px;
		text-indent: 85px;
		color: #CFD4D6;
		margin-bottom: 30px;
	}
	
	.up_box {
		margin-bottom: 13px;
	}
	
	.jfpz {
		display: inline-block;
		font-size: 16px;
		font-weight: bold;
		color: #404040;
	}
	
	.up {
		display: inline-block;
		top: 45px;
		right: 45px;
		color: #fff;
		width: 124px;
		height: 40px;
		background: #0076ff;
		border-radius: 3px;
		border: none;
		box-sizing: border-box;
		margin: 0 30px 0 20px;
	}
	
	.con_con_bot {
		width: 100%;
		height: 454px;
	}
	
	.ul1 {
		width: 760px;
		height: 54px;
		background: rgba(250, 250, 250, 1);
		border-radius: 4px 4px 0px 0px;
	}
	
	.ul1 li {
		float: left;
		line-height: 54px;
		text-align: center;
	}
	
	.w1 {
		width: 280px;
	}
	
	.w2 {
		width: 150px;
	}
	
	.w3 {
		width: 180px;
	}
	
	.page_con {
		width: 760px;
		height: 180px;
		margin-bottom: 20px;
	}
	
	.ul2 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 54px;
		border-radius: 4px 4px 0px 0px;
	}
	
	.ul2 li {
		float: left;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Huifei.vue